import { render, staticRenderFns } from "./mock-phone.vue?vue&type=template&id=1ef48f94&scoped=true&"
import script from "./mock-phone.vue?vue&type=script&lang=js&"
export * from "./mock-phone.vue?vue&type=script&lang=js&"
import style0 from "./mock-phone.vue?vue&type=style&index=0&id=1ef48f94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef48f94",
  null
  
)

export default component.exports